/**
 * Common
 */
export const GAMES_RESOURCE_NAME = 'games';
export const GAMES_SEARCH_FIELD = 'translationKey';
export const COUNT_OF_SIMILAR_GAMES = 6;

/**
 * UI actions
 */
export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const SET_SEARCH_FOCUS = 'SET_SEARCH_FOCUS';
